import { useState, useEffect } from "react";

// Componente de animação — aplica efeito de surgimento (fade-in) com deslocamento vertical
// Aceita prop "delay" para atrasar o início da animação em milissegundos
function FadeIn({ children, delay = 0 }) {
  // Estado que controla a visibilidade do conteúdo
  const [visible, setVisible] = useState(false);

  // Após o delay, torna o conteúdo visível e dispara a transição CSS
  useEffect(() => {
    const t = setTimeout(() => setVisible(true), delay);
    return () => clearTimeout(t);
  }, [delay]);
  return (
    <div
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(20px)",
        transition: "opacity 0.6s ease, transform 0.6s ease",
      }}
    >
      {children}
    </div>
  );
}

export default FadeIn;
